/* Minimal Menu Drawer for Dawn – safe stub */
if (!customElements.get('menu-drawer')) {
  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', this.getAttribute('role') || 'dialog');
      this.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') this.close();
      });
      this.querySelectorAll('[data-action="close-drawer"]').forEach((b) =>
        b.addEventListener('click', () => this.close())
      );
    }
    open() {
      this.setAttribute('open', '');
      document.documentElement.classList.add('overflow-hidden');
    }
    close() {
      this.removeAttribute('open');
      document.documentElement.classList.remove('overflow-hidden');
    }
  }
  customElements.define('menu-drawer', MenuDrawer);
}

/* Header wrapper (algunas versiones de Dawn lo usan) */
if (!customElements.get('header-drawer')) {
  class HeaderDrawer extends HTMLElement {}
  customElements.define('header-drawer', HeaderDrawer);
}
